import $ from 'jquery';
export { $ as $, $ as jQuery };
